import gql from 'graphql-tag';

const UPDATE_SECTOR_PICKING = gql`
    mutation editSectorPicking($input: SectorPickingInput) {
        editSectorPicking(input: $input) {
            internalCode
        }
    }
`;

export default UPDATE_SECTOR_PICKING;
